import type { Line } from "../components/Terminal";
import type { Resume } from "./resume";

export function resumeToLines(resume: Resume): Line[] {
    const lines: Line[] = [];

    const push = (text: string, className?: string, href?: string) => lines.push({ text, className, ...(href && { href }) });
    const blank = (count: number = 1) => { for (let i = 0; i < count; i++) { push("\u00a0") } };

    push(resume.contact.name, "text-term-bright font-bold");
    push(resume.contact.location);
    push(resume.contact.email, undefined, `mailto:${resume.contact.email}`);
    push(resume.contact.linkedin, undefined, resume.contact.linkedin);

    blank();
    push("── summary ─────────────────────────────", "text-term-dim");
    push(resume.summary);

    blank(2);
    push("── experience ───────────────────────────", "text-term-dim");
    for (const job of resume.experience) {
        push(`${job.title}  ·  ${job.company}`, "text-term-bright");
        push(job.period, "text-term-dim");
        blank();
        for (const bullet of job.bullets) {
            push(`\u00a0\u00a0• ${bullet}`);
        }
        blank();
    }

    blank(2);
    push("── education ────────────────────────────", "text-term-dim");
    for (const edu of resume.education) {
        push(edu.degree, "text-term-bright");
        push(`${edu.institution}  ·  ${edu.year}`, "text-term-dim");
    }

    blank(2);
    push("── skills ───────────────────────────────", "text-term-dim");
    push(resume.skills.join("  ·  "));

    return lines;
}
